// formUi/TasteSlider.js
export class TasteSlider {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;
    this.store = app.store;

    // data-target="taste4" を利用（将来 taste1〜3 を増やしたくなっても対応可）
    this.target = this.node?.dataset.target || 'taste4';

    // 初期値を value から取得
    const initialValue = this.node ? Number(this.node.value) : undefined;

    this.params = {};
    if (!Number.isNaN(initialValue)) {
      this.params[this.target] = initialValue; // 0,1,2,-1,-2 など
    }

    if (this.node) {
      this.node.addEventListener('change', () => {
        this.handleChange();
      });
    }
  }

  handleChange() {
    if (!this.node) return;

    const raw = this.node.value;
    const num = Number(raw);

    const tasteState = this.app.getState('taste') || {};

    this.app.setState('taste', {
      ...tasteState,
      [this.target]: Number.isNaN(num)
        ? (tasteState[this.target] ?? 0) // NaN の時は元の値か 0 にフォールバック
        : num,
    });
  }

  render() {
    if (!this.node) return;

    const tasteState = this.app.getState('taste') || {};
    const value = tasteState[this.target];

    if (value != null && !Number.isNaN(value)) {
      this.node.value = value;
    }
  }
}
